import { Reducer } from "redux";

import { ServiceRequestDisciplinesResponse } from "../models/Api/Document";
import { ServiceRequestDisciplinesActionDispatchTypes } from "../constants/Document";
import { ServiceRequestDisciplinesDispatchTypes } from "../models/DispatchTypes/Document";

export const initialState: ServiceRequestDisciplinesResponse = {
  loading: false,
  response: [],
};

const serviceRequestDisciplinesReducer: Reducer<
  ServiceRequestDisciplinesResponse,
  ServiceRequestDisciplinesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_RESET: {
      return initialState;
    }
    case ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default serviceRequestDisciplinesReducer;
